<script setup lang="ts">
import { computed, ref } from 'vue'
import { useSlider } from '@/composables/helpers/slider'
import type { BackpackItem } from '@/composables/game/backpack'
import InventoryCard from '@/components/InventoryCard.vue'

const { onMouseDown, onMouseUp, onMouseMove } = useSlider()
const slider = ref<HTMLElement | null>(null)

const props = defineProps<{
	items: BackpackItem[]
	cardBgClass: string
	itemTooltipOverrides?: Record<string, string>
}>()

const emit = defineEmits<{
  itemClick: [item: BackpackItem]
}>()

const sortedItems = computed(() => {
  return [...props.items].sort((a, b) => {
    if (a.value === 0 && b.value !== 0) return 1
    if (a.value !== 0 && b.value === 0) return -1
    return 0
  })
})

</script>

<template>
  <div
    ref="slider"
    class="-mx-4 card-slider flex gap-x-2 overflow-x-auto select-none pt-2 -mt-1"
    @mousedown="onMouseDown"
    @mouseup="onMouseUp"
    @mouseleave="onMouseUp"
    @mousemove="onMouseMove"
  >
    <div
      v-for="(item, index) in sortedItems"
      :key="index"
      class="flex-none"
      :class="{'pl-4 w-[106px]': index === 0, 'pr-4 w-[106px]' : index === sortedItems.length - 1 && sortedItems.length > 1, 'w-[90px]': index > 0 &&
        index < sortedItems.length - 1}"
    >
      <InventoryCard
        class="w-full"
        :current-value="item.value"
        :image="item.image"
        :label="item.name"
        :is-new="item.isNew"
        :card-class="cardBgClass"
        @click="emit('itemClick', item)"
      />
    </div>
  </div>
</template>

<style scoped>
.card-slider::-webkit-scrollbar {
	display: none; /* Hide scrollbar for WebKit browsers */
}

.card-slider {
	-ms-overflow-style: none; /* Hide scrollbar for IE/Edge */
	scrollbar-width: none; /* Hide scrollbar for Firefox */
}
</style>